import { Rating, Box, Typography } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';

interface RatingSelectorProps {
  value: number;
  onChange: (value: number) => void;
  readOnly?: boolean;
  showLabel?: boolean;
}

export default function RatingSelector({
  value,
  onChange,
  readOnly = false,
  showLabel = true,
}: RatingSelectorProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {showLabel && (
        <Typography variant="body2" color="text.secondary">
          Rating:
        </Typography>
      )}
      <Rating
        value={value}
        onChange={(_, newValue) => {
          if (newValue !== null) {
            onChange(newValue);
          }
        }}
        max={5}
        readOnly={readOnly}
        icon={<StarIcon fontSize="inherit" />}
        emptyIcon={<StarIcon fontSize="inherit" />}
      />
    </Box>
  );
}
